import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {
  private _isExpanded = signal(true);
  private _isMobile = signal(false);

  isExpanded = this._isExpanded.asReadonly();
  isMobile = this._isMobile.asReadonly();

  toggle() {
    this._isExpanded.update(value => !value);
  }

  expand() {
    this._isExpanded.set(true);
  }

  collapse() {
    this._isExpanded.set(false);
  }

  setMobile(isMobile: boolean) {
    this._isMobile.set(isMobile);
    if (isMobile) {
      this._isExpanded.set(false);
    }
  }
}
